'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('services.configuration', [])

.factory('configurationService', ['$http', '$q', function ($http, $q) {

    var service = {};

    service.getAppSettings = function () {
        return $http
            .get(environment.apiUrl + '/Pilot/api/Configuration/AppSetting')
            .then(function (response) { return response.data; });
    };

    return service;
}]);
